export function getCurrentPrivateLounge(state) {
    return state.PrivateLoungeReducer.privateLounge;
}

export function getUserPrivateLounge(state) {
    return state.PrivateLoungeReducer.userPrivateLounge;
}

export function getPrivateLounges(state) {
    return state.PrivateLoungeReducer.privateLounges;
}
